import { render, staticRenderFns } from "./SeverityMix.vue?vue&type=template&id=2f62cb2d&scoped=true&"
import script from "./SeverityMix.vue?vue&type=script&lang=js&"
export * from "./SeverityMix.vue?vue&type=script&lang=js&"
import style0 from "./SeverityMix.vue?vue&type=style&index=0&id=2f62cb2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f62cb2d",
  null
  
)

export default component.exports